<template>
    <div>
<!--&lt;!&ndash;      <breadcrumb :routerList="[{to:'/invoice/applyList',title:'可开票确认'},{title:'可开票确认详情'}]"/>&ndash;&gt;-->
      <Breadtabsheader/>
      <div class="h-content">
                <div class="h-piece">
                        <div class="h-formBox">
                          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" @submit.native.prevent>
                              <div class="h-thirdColumn w-newColumn" >
                                <el-form-item label="供应商" >
                                  <el-input clearable v-model="q.supplierCode"></el-input>
                                </el-form-item>
                                <el-form-item label="公司主体" >
                <brselect category="kkber_value_kp" v-model="q.companyCode" clearable :v="q.companyCode"
                  @change="handleFilter"></brselect>
                                </el-form-item>
                                <el-form-item label="报关单号" prop="customsCode"  style="width: 50%;">
                                  <el-input v-model="q.customsCode" placeholder="多单号模糊查询请用空格或分号分隔"></el-input>
                                </el-form-item>

                              </div>

                            <el-collapse-transition>
                              <div v-show="isScreen">

                            <div class="h-thirdColumn w-newColumn" >
                              <el-form-item label="采购订单号" prop="cgCode" style="width: 50%;">
                                <el-input v-model="q.cgCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                              </el-form-item>

                              <el-form-item label="sap订单号" prop="orderNumber" style="width: 50%;">
                                <el-input v-model="q.orderNumber" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                              </el-form-item>
                            </div>
<!--                              <div class="h-thirdColumn w-newColumn" >
                                <el-form-item label="状态">
                                  <el-select v-model="q.status" placeholder="请选择">
                                    <el-option label="已开票" value="2"></el-option>
                                    <el-option label="未开票" value="1"></el-option>
                                  </el-select>
                                </el-form-item>
                              </div>-->
                              </div>
                            </el-collapse-transition>
                            </el-form>
                          <div class="l-screenBox">
                            <div class="l-screen" @click="collapseChange">
                              <img :src="isScreen?closeScreen:drawScreen" alt="">
                              <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                            </div>
                            <div class="l-retrieval">
                              <el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
                              <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            </div>
                          </div>
                        </div>
                </div>
          <div class="h-row">
        <div class="h-rowIn" style="width:100%;">
          <searchApplySupplierDetails
              :customsCode="this.detail.customsCode"
              :supplierCode="this.detail.supplierCode"
              :org="this.detail.org"
              :visible.sync="showSearchDialog"
              v-if="showSearchDialog"
              title="详情"/>

          <div class="h-rowBox" style="border-bottom: none;box-shadow: none;">
            <el-table max-height="500px" size="mini" ref="multipleTable" :data="tableData" :border="true"
                      tooltip-effect="dark" @selection-change="handleSelectionChange" style="width: 100%" >
              <el-table-column type="selection" width="40" fixed="left">
              </el-table-column>
              <el-table-column type="index" width="45" fixed="left" label="#">
              </el-table-column>
              <el-table-column prop="supplierName" label="供应商" fixed="left" width="260" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  {{ scope.row.supplierName }}-{{ scope.row.supplierCode }}
                </template>
              </el-table-column>
              <el-table-column prop="org" label="采购公司代码" width="90" > </el-table-column>
              <el-table-column prop="customsCode" label="报关单号" width="180" > </el-table-column>
              <el-table-column prop="cgCode" label="采购订单号" width="100" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="sapCode" label="销售订单号" width="100" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="sapCodeCg" label="sap订单号" width="100" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="proType" label="产品属性"  :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="currency" label="币种" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column
                  fixed="right"
                  label="操作"
                  width="100"
              >
                <template slot-scope="scope">
                  <div style="text-align: left;">
                    <el-button
                        type="text"
                        size="small"
                        @click="getDetail(scope.row)"
                        class="h-tableLink h-btn">
                      查看
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="left" style="height: 50px">
<!--        <div style="justify-content: space-between;flex-direction:row-reverse;margin-top:1px">
          <span>合计金额：</span><span style="color: red">{{ form.totalMoney }}</span>
        </div>-->
        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
          @click="exportExcel">导出</el-button>
<!--        <el-button class="h-btn h-formBtn h-bgblueQ" @click="createApplyTs" >生成发票</el-button>-->
        <pagination :page="q" @query="checkData" />
      </div>

      <createApply :visible.sync="showInvoiceDialog" v-if="showInvoiceDialog" @saveorsubmit="closeDialog"
        :orderList="this.multipleSelection" :supplierCode="this.supplierCode" :supplierName="this.supplierName"
        :companyCode="this.companyCode" title="创建发票" />

      <createApplyTs :visible.sync="showInvoiceDialogTs" v-if="showInvoiceDialogTs" @saveorsubmit="closeDialogTs"
                   :orderList="this.multipleSelection" :supplierCode="this.supplierCode" :supplierName="this.supplierName"
                   :companyCode="this.org" :companyCodeType="this.gscode" title="创建发票" />

        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import createApply from '../apply/createApplyToSrm'
    import createApplyTs from '../apply/createApplyToSrmTs'
    import searchApplySupplierDetails from '../apply/searchApplySupplierDetails'
    export default {
        name: "alluser",
        components: {createApply,createApplyTs,searchApplySupplierDetails},
        data(){
            return {
                id:null,
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                supplierCode:null,
                supplierName:null,
                soldToCode:null,
                soldToName:null,
                companyCode:null,
                gscode:null,
                form:{
                  pageSize: 10,
                  pageNo: 1,
                },
                tableData:[],
                fileList:[],
                multipleSelection:[],//选中的数据
                q:{
                  pageSize: 10,
                  pageNo: 1,
                  total: 0
                },
                detail:{

                },
                //查询属性
                isCheck:null,
                showInvoiceDialog:false,
                showInvoiceDialogTs:false,
                showSearchDialog:false,
                isTuishui:false,
                isAll:false,
                activeName: 'first',
                ids:'',
                indx: 0,
                item:'',
            }
        },
        methods: {
          fun(val){
            return Number(val).toFixed(3);
          },
      handleFilter(){
            console.log("queryquery",this.q);
            ss.invoiceApplyList.selectSupplierTablePage(this.q).then(rd=> {
              console.log("rd",rd);
              this.form=rd.records;
              this.tableData = rd.records;
              this.q.total = rd.total;
              var sum = 0;
              /*  this.form.forEach(element => {
                  sum += element.includeTaxAmount;
                });*/
              this.form.totalMoney = sum.toFixed(2);
            });
            //进行强制数据渲染
            this.$forceUpdate();
      },
            checkData(){
              this.handleFilter();
            },
            // 展开折叠
            collapseChange(){
              this.isScreen = !this.isScreen;
            },
            exportExcel(){
              var q = this.q;
              q.id=this.id;
              updownfile.down("/api/swyl/v1/demo/bscTaxInvoice/downloadSupplierExcel",q,"get",'params');
            },
            resetData(){
              this.q.companyCode = '';
              this.q.orderNumber = '';
              this.q.status = '';
              this.q.supplierCode = '';
              this.q.confirmed = '';
              this.q.cgCode = '';
              this.q.billNo = '';
              this.q.invoiceNumber = '';
              this.q.ifCheck = '';
              this.q.customsCode = '';
            },

            handlePreview(file){

                window.open(file.saveurl);
            },
            //查询
            getDetail(query){
              this.detail.customsCode = query.customsCode
              this.detail.supplierCode = query.supplierCode
              this.detail.org = query.org
              this.showSearchDialog = true;
            },

            //方法区
            formatDate(row, column) {
                // 获取单元格数据
                let date = row[column.property];
                if (date) {
                    return this.transformDate(date)
                } else {
                    return ''
                }
            },
            //标准时间格式转yyyy-MM-dd
            transformDate(date) {
                if (date) {
                    let dt = new Date(date);
                    return dt.getFullYear() + '-' +
                        ((dt.getMonth() + 1) < 10 ? ('0' + (dt.getMonth() + 1)) : (dt.getMonth() + 1)) + '-' +
                        (dt.getDate() < 10 ? ('0' + dt.getDate()) : dt.getDate());
                } else {
                    return ''
                }
            },
          //勾选事件
          handleSelectionChange(val) {
            this.multipleSelection = val;
            var sum = 0;
            this.multipleSelection.forEach(element => {
              element.syNum = element.availableNum - element.proNumber;
              sum += element.includeTaxAmount;
            });
            this.supplierCode=val[0].supplierCode;
            this.soldToCode=val[0].soldToCode;
            this.soldToName=val[0].soldToName;
            this.companyCode=val[0].companyCode;
            this.gscode=val[0].gscode;
            this.supplierName=val[0].supplierName;
            this.form.totalMoney = sum.toFixed(2);
            //进行强制数据渲染
            this.$forceUpdate();
          },
            dataUpdate() {
              this.$forceUpdate()
            },
            //返回上页
            fanhuishangye() {
              //跳转
              this.$router.push("/invoice/applyList");
            },
            createApplyTs(){
              if(this.multipleSelection.length==0){
                this.$message.error("请选择需要提交的明细");
                return;
              }
              //勾选同一个采购订单
              var cgFlag = false;
              var customsCodes = this.multipleSelection[0].customsCode;
              this.multipleSelection.forEach(element => {
                if(customsCodes != element.customsCode){
                  cgFlag = true;
                }
              });
              if(cgFlag){
                this.$message.error("请勾选同一报关单号数据！");
                return;
              }
              this.showInvoiceDialogTs = true;
            },
            closeDialog(){
                this.showInvoiceDialog = false;
                this.handleFilter();
            },
            closeDialogTs(){
              this.showInvoiceDialogTs = false;
              this.handleFilter();
            },
        },
        created(){
            this.q.confirmed = '0';
            this.checkData();
            this.isTuishui = this.$store.getters.hasRole('tuishui_jl');
            this.isAll = this.$store.getters.hasRole('swyl_admin');
        },
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuqiuBoxList .xuqiulist.active {
      background: #238cfd;
      border: 1px solid #238cfd;
      color: #fff;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
    .w-tongyi {
        padding: 0.1rem 0.25rem;
    }
    .tan.h-formBorder .h-elformWrap-2{
        width: 50%;
    }
    .tan.h-formBorder .h-elformWrap-2 .el-form-item__label{
        width: 22%;
    }
    .tan.h-formBorder .h-elformWrap-2 .el-form-item__content{
        width: 78%;
    }
    /deep/.el-upload-list__item.is-success.focusing .el-icon-close-tip{
        　　display: none !important;
    }
</style>
